/* Worn views: Jose's model photos, 10 Sep 2026. Added from this file, not the theme: a Stage
   builds its chips from whatever .view figures its track holds when it starts, and this runs
   first. Each worn view copies the colourway of the Black (or single-colour) Front beside it.
   ASCII only: this file is served without a declared charset. */
(function(){
  /* The fifth value is the photo's own wall at its left and right edges (top, middle, bottom),
     measured on the uploaded crops. The stage letterboxes a square photo into a wider frame on
     phones, and its #c8c8c8 ground showed as pale strips beside the darker wall - 40px a side on
     Struck God at 390px. Painting the figure in the wall's colour closes them.
     The sixth value is the photo's version. Shopify's CDN keeps serving a replaced file's old bytes
     under the same URL for up to a year, so a photo that changes gets the next number here, in the
     same publish - and nothing may request the new number before the new file is live. A local
     test requested v2 while the old crop was still up, which may have cached it under v2 at the
     edge, so the 11 Sep re-crop of Stratum Head back (closer, centred) is v3. */
  var WORN = [
    ["struck", "front", "Worn", "The black STRUCK GOD tee, worn - front print", "#95908d,#9a9793,#9a9694", "1"],
    ["stratum", "front", "Worn", "The black STRATUM HEAD tee, worn - the chest line", "#8d8d8e,#929192,#909090", "1"],
    ["stratum", "back", "Worn back", "The black STRATUM HEAD tee, worn - back print", "#898889,#8f8d8e,#929291", "3"],
    ["grew", "front", "Worn", "The black GREW ANYWAY tee, worn - the chest line", "#a29e99,#a4a19d,#a3a09b", "1"],
    ["grew", "back", "Worn back", "The black GREW ANYWAY tee, worn - back print", "#a19f9d,#a2a29f,#a2a19f", "1"],
    ["gap", "front", "Worn", "The black THE GAP tee, worn - front print", "#a29e9a,#a3a29e,#a29f9c", "1"]
  ];
  WORN.forEach(function(w){
    /* by class: Grew Anyway and The Gap have one colourway and carry no data-p */
    var track = document.querySelector('.panel--' + w[0] + ' [data-track]');
    var ref = track && track.querySelector('.view--photo[data-cw="Black"] img[data-src], .view--photo[data-cw="*"] img[data-src]');
    if (!ref) return;
    var from = ref.getAttribute("data-src");
    var src = from.replace(/as-rd-[a-z]+-blk-(front|back)\.jpg(\?.*)?$/, "as-wn-" + w[0] + "-blk-" + w[1] + ".jpg?v=" + w[5]);
    if (src === from) return;
    var f = document.createElement("figure");
    f.className = "view view--photo";
    f.setAttribute("data-cw", ref.parentNode.getAttribute("data-cw"));
    f.setAttribute("data-label", w[2]);
    f.setAttribute("role", "group");
    f.setAttribute("aria-roledescription", "slide");
    f.setAttribute("aria-hidden", "true");
    f.style.background = "linear-gradient(" + w[4] + ")";
    var im = document.createElement("img");
    im.className = "im im--photo";
    im.setAttribute("data-img-src", "wn-" + w[0] + "-blk-" + w[1]);
    im.setAttribute("data-src", src);
    im.width = 1200;
    im.height = 1200;
    im.decoding = "async";
    im.alt = w[3];
    f.appendChild(im);
    track.appendChild(f);
  });
  /* Five chips are 330px; at 320 the last one clipped by 2px. Each rule needs one class more than
     the rule it beats: this style lands in <head>, as-feed.css loads later in <body> and wins ties.
     - the fullscreen viewer's chip row wraps "Worn back" below ~352px
     - on desktop stages taller than wide, a worn photo sits at the bottom, so the band falls above
       it and the photo's cut edge hides behind the chip strip
     - (11 Sep) holding a finger on a stage photo while scrolling started the phone's own
       press-and-hold image preview, which zooms the photo up and back; the stage and the big
       product names no longer offer that preview or a text-selection magnifier
     (The viewer title that "Worn back" makes too long is handled in worn-tail.js.) */
  var css = document.createElement("style");
  css.textContent = "@media (max-width:339px){.panel--stratum .stage .gal button,.panel--grew .stage .gal button{padding:0 9px}}"
    + "@media (max-width:359px){.look .look-gal button{padding:0 9px}}"
    + '.stage .view--photo .im[data-img-src^="wn-"]{object-position:50% 100%}'
    + ".panel .stage,.panel .stage img,.panel .name,.panel .ga-name,.panel .gp-name"
    + "{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}";
  document.head.appendChild(css);
})();
document.documentElement.className += " js";
/* This page is published as an Artifact, so the <html> and <head> are the host's, not ours.
   The two things a document owes a reader and a crawler are set from here instead. */
if (!document.documentElement.lang) document.documentElement.lang = "en";
if (!document.querySelector('meta[name="description"]')){
  var md = document.createElement("meta");
  md.name = "description";
  md.content = "AFTERSTONE - heavyweight garment-dyed tees, pressed in Florida. Four pieces, black and ivory, free US shipping.";
  (document.head || document.documentElement).appendChild(md);
}
/* Closing a sheet is a history.back(). With scroll restoration on "auto" the browser then
   restores the scroll position it RECORDED for that entry - 0 from page load - and fights the
   page's own restore. Measured: closing the FAQ sheet from the closing panel landed at 0. */
if ("scrollRestoration" in history) history.scrollRestoration = "manual";

/* Live stock. Injected by build.py from stock.json - see the timestamp at the top of index.html. */
var __d = document.getElementById("as-data");
  var DATA = __d ? JSON.parse(__d.textContent) : {};
var SIZES = ["S","M","L"];
  var PRICE = __d ? (JSON.parse(__d.textContent).__price || 45) : 45;
var DOT = "·", DASH = "—";
var state = {}, bag = [], toastTimer;
var RM = matchMedia("(prefers-reduced-motion: reduce)");
var root = document.documentElement;

/* sheet detail images reuse the panel bitmaps - never a second base64 copy */
document.querySelectorAll("[data-img-clone]").forEach(function(el){
  var from = document.querySelector('[data-img-src="' + el.dataset.imgClone + '"]');
  var uri = from && (from.getAttribute("src") || from.dataset.src);
  if (uri) el.src = uri;            /* never fall through to .src - it resolves to the page */
  else el.remove();
});

function say(msg){
  var t = document.getElementById("toast");
  t.textContent = msg;
  t.classList.add("on");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function(){ t.classList.remove("on"); }, 2400);
}
function firstInStock(key, cw){
  for (var i = 0; i < SIZES.length; i++) if (DATA[key][cw][SIZES[i]].q > 0) return SIZES[i];
  return null;
}

/* ---------------------------- buy controls ---------------------------- */
function paint(panel){
  var key = panel.dataset.p, d = DATA[key], st = state[key];
  var box = panel.querySelector("[data-sz]");
  if (!box.dataset.wired){
    box.dataset.wired = "1";
    box.querySelectorAll(".sz").forEach(function(b){
      b.addEventListener("click", function(){
        if (b.disabled) return;
        state[key].size = b.dataset.s;
        paint(panel);
      });
    });
  }
  var anyLeft = false;
  box.querySelectorAll(".sz").forEach(function(b){
    var q = d[st.cw][b.dataset.s].q;
    b.disabled = q === 0;
    if (q > 0){ anyLeft = true; b.removeAttribute("aria-label"); }
    else b.setAttribute("aria-label", b.dataset.s + " sold out");
    b.setAttribute("aria-pressed", String(q > 0 && st.size === b.dataset.s));
  });
  panel.querySelectorAll("[data-cw] button").forEach(function(b){
    b.setAttribute("aria-pressed", String(b.dataset.c === st.cw));
  });
  panel.querySelector("[data-stage]").dataset.ground = st.cw;
  var add = panel.querySelector("[data-add]");
  if (add.classList.contains("done")){ clearTimeout(add._t); add.classList.remove("done"); }   /* a picker change ends the confirmation */
  if (!anyLeft)      { add.disabled = true;  add.textContent = "Sold out in " + st.cw.toLowerCase(); }
  else if (!st.size) { add.disabled = true;  add.textContent = "Select a size"; }
  else               { add.disabled = false; add.textContent = "Add to bag " + DOT + " $" + PRICE; }
}

document.querySelectorAll(".panel[data-p]").forEach(function(panel){
  var key = panel.dataset.p;
  var cw = firstInStock(key, "Black") ? "Black" : "Ivory";
  state[key] = { cw: cw, size: firstInStock(key, cw) };

  panel.querySelectorAll("[data-cw] button").forEach(function(b){
    b.addEventListener("click", function(){
      if (state[key].cw === b.dataset.c) return;
      var prev = state[key].size, next = b.dataset.c;
      state[key].cw = next;
      /* keep the chosen size when the new colourway has it; only then may the toast say "sold out" */
      var keep = prev && DATA[key][next][prev] && DATA[key][next][prev].q > 0;
      state[key].size = keep ? prev : firstInStock(key, next);
      if (panel.classList.contains("panel--stratum") && !RM.matches){
        panel.classList.remove("cw-swap");
        void panel.offsetWidth;
        panel.classList.add("cw-swap");
      }
      paint(panel);
      stageOf(panel).set();
      if (state[key].size && prev && !keep)
        say(next + " " + DASH + " size " + state[key].size + " selected, " + prev + " sold out");
    });
  });

  panel.querySelector("[data-add]").addEventListener("click", function(){
    var st = state[key];
    /* the confirmation is the way in, but not for the second half of a double tap: the label
       changes under the finger, and a customer tapping Add twice means "two", not "show me the bag" */
    if (this.dataset.done){
      if (Date.now() - (this._done || 0) > 700) go("#bag");
      return;
    }
    if (!st.size) return;
    addToBag(key, st.cw, st.size);
    /* the button itself confirms, for 1.4 s, then goes back to being the button; the
       announcement goes to the live region, not the toast, so nothing lands on the name */
    if (live) live.textContent = DATA[key].title + " " + DOT + " " + st.cw + " " + st.size + " added";
    var btn = this;
    clearTimeout(btn._t);
    btn.classList.add("done"); btn.dataset.done = "1"; btn._done = Date.now();
    btn.textContent = "Added " + DOT + " " + st.cw + " " + st.size + "  " + DASH + "  View bag";
    btn._t = setTimeout(function(){
      btn.classList.remove("done"); delete btn.dataset.done; paint(panel);
    }, 2400);
  });

  paint(panel);
});

/* ------------------------------- the stage ------------------------------- */
/* Every product panel has a stage: film -> worn (the clip) -> front -> back -> print,
   in a frame whose height never changes, so a view change can never move Add to bag.
   It is MANUAL: a swipe, a chip or an arrow key moves it; nothing moves on its own
   (Jose, 5 Sep: "take the auto scroll off ... just have it normal where people swipe").
   The clip plays once, muted, when its view is current and the panel is on screen.
   The markup is the manifest (data-cw and data-label on every .view); the chip strip is
   built from whichever views match the colourway in play. Clips carry preload="none"
   and only get a src when their panel is the current one or the next. */
var stages = [], overlayHold = false;
var live = document.getElementById("stagelive");

function Stage(panel){
  var self = this;
  this.panel = panel;
  this.el = panel.querySelector("[data-stage]");
  this.track = this.el.querySelector("[data-track]");
  this.rail = panel.querySelector("[data-gal]");
  this.all = [].slice.call(this.track.querySelectorAll(".view"));
  this.all.forEach(function(v){ [].slice.call(v.querySelectorAll("img")).forEach(function(im){ im.draggable = false; }); });
  this.views = []; this.i = 0;
  this.rail.addEventListener("keydown", function(e){
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
    var n = self.i + (e.key === "ArrowRight" ? 1 : -1);
    if (n < 0 || n >= self.views.length) return;
    e.preventDefault();
    self.seat(n);
    var b = self.rail.querySelectorAll("button")[n];
    if (b) b.focus();
    if (live) live.textContent = (self.views[n].dataset.label || "View") + " view";
  });
  /* arrows: the swipe, made visible. Outside the chip strip so the strip stays the manifest. */
  this.arrows = ["l", "r"].map(function(side){
    var a = document.createElement("button");
    a.type = "button"; a.className = "arrow arrow--" + side;
    a.setAttribute("aria-label", side === "l" ? "Previous view" : "Next view");
    a.textContent = side === "l" ? "‹" : "›";
    a.addEventListener("click", function(){
      var n = self.i + (side === "l" ? -1 : 1);
      if (n >= 0 && n < self.views.length){ self.seat(n); if (live) live.textContent = (self.views[n].dataset.label || "View") + " view"; }
    });
    self.el.appendChild(a);
    return a;
  });
  this.drag();
  this.set();
}
Stage.prototype.cw = function(){
  var key = this.panel.dataset.p;
  return key && state[key] ? state[key].cw : null;
};
/* (re)build for the colourway in play: which views exist, and the chips */
Stage.prototype.set = function(){
  var self = this, cw = this.cw();
  /* remember WHICH view you were looking at, not its number: Black and Ivory carry the same
     labels but not always the same count, so switching colour used to dump you back on the
     artwork slide. */
  var held = this.views.length ? (this.views[this.i] || {}).dataset : null;
  var heldLabel = held ? held.label : null;
  this.views = this.all.filter(function(v){
    return v.dataset.cw === "*" || !cw || v.dataset.cw === cw;
  });
  this.all.forEach(function(v){
    var out = self.views.indexOf(v) < 0;
    v.hidden = out;
    if (out) v.setAttribute("aria-hidden", "true");   /* a dropped view must not stay "visible" */
  });
  this.rail.textContent = "";
  this.views.forEach(function(v, n){
    var b = document.createElement("button");
    b.type = "button";
    b.view = v;
    b.textContent = v.dataset.label || "View";
    b.setAttribute("aria-pressed", "false");
    b.addEventListener("click", function(){
      self.seat(n);
      if (live) live.textContent = b.textContent + " view";
    });
    self.rail.appendChild(b);
  });
  var back = 0;
  if (heldLabel) for (var q = 0; q < this.views.length; q++)
    if (this.views[q].dataset.label === heldLabel){ back = q; break; }
  this.seat(back, true);
};
/* make view n current. Only the track moves. */
Stage.prototype.seat = function(n, instant){
  var lv = this.views[n];
  if (lv){
    this.panel.dataset.view = lv.dataset.label || "";
    /* the ground follows the view, so the chips and arrows can flip their ink on how light
       it is rather than on whether the slide happens to be a film */
    this.el.dataset.bg = lv.dataset.bg || (lv.classList.contains("view--film") ? "black" : "studio");
  }
  var self = this;
  this.i = n;
  if (instant) this.track.classList.add("nofx");
  this.track.style.setProperty("--i", n);
  if (instant){ void this.track.offsetWidth; this.track.classList.remove("nofx"); }
  this.views.forEach(function(v, k){
    var on = k === n;
    v.setAttribute("aria-hidden", String(!on));
    var im = v.querySelector("img");
    if (on && im && !im.getAttribute("src") && im.dataset.src) im.src = im.dataset.src;
  });
  [].slice.call(this.rail.querySelectorAll("button")).forEach(function(b){
    if (b.view) b.setAttribute("aria-pressed", String(b.view === self.views[n]));
  });
  if (this.arrows){ this.arrows[0].hidden = n === 0; this.arrows[1].hidden = n >= this.views.length - 1; }
  /* BOTH neighbours decode now, off the swipe.  Loading only the next one meant swiping
     back showed an empty studio square for a frame while the previous photograph decoded. */
  var len = this.views.length;
  if (len > 1) [ (n + 1) % len, (n - 1 + len) % len ].forEach(function(k){
    var nim = self.views[k] && self.views[k].querySelector("img");
    if (nim && !nim.getAttribute("src") && nim.dataset.src){
      nim.src = nim.dataset.src;
      if (nim.decode) nim.decode().catch(function(){});
    }
  });
};
Stage.prototype.sync = function(){};      /* nothing runs on its own any more */
/* a horizontal drag moves the track under the finger; a vertical one is the page's.
   touch-action:pan-y on the stage keeps vertical scrolling native and the lock is decided
   in the first 10px.  Two traps live here:
   - explicit setPointerCapture is for MOUSE ONLY.  Touch already has implicit capture on
     the element that took the pointerdown, and re-capturing to the stage fires
     lostpointercapture at that child - which BUBBLES to the stage and used to end the drag
     one frame after it started.  That is why swiping did nothing while the arrows worked.
   - end() can null the drag from inside a move, so every use of d after it is re-checked. */
Stage.prototype.drag = function(){
  var self = this, el = this.el, track = this.track, d = null;
  el.addEventListener("pointerdown", function(e){
    if (e.pointerType === "mouse" && e.button !== 0) return;
    if (e.target.closest("[data-gal]")) return;
    if (d || !e.isPrimary) return;              /* one finger drives the track; a second is ignored */
    d = { id:e.pointerId, x0:e.clientX, y0:e.clientY, t0:performance.now(), dx:0, lock:null,
          tgt:e.target, mouse:e.pointerType === "mouse" };
  });
  el.addEventListener("pointermove", function(e){
    if (!d || e.pointerId !== d.id) return;
    var dx = e.clientX - d.x0, dy = e.clientY - d.y0;
    if (d.lock === "y") return;                 /* the page owns this gesture now */
    if (!d.lock){
      var ax = Math.abs(dx), ay = Math.abs(dy);
      if (ay >= 14 && ay > ax * 1.35){ d.lock = "y"; return; }   /* clearly a scroll - let go */
      if (ax < 10) return;                                       /* not moved enough to call it */
      if (ax <= ay) return;                                      /* diagonal: wait, do not kill */
      d.lock = "x";
      if (d.mouse){ try { el.setPointerCapture(e.pointerId); } catch(err){} }
      el.classList.add("dragging");
      if (!d) return;                           /* a capture event may have ended us */
    }
    if (e.cancelable) e.preventDefault();       /* we own the horizontal axis from here */
    d.dx = dx;
    var n = self.views.length;
    var edge = (self.i === 0 && dx > 0) || (self.i === n - 1 && dx < 0);
    track.style.transform = "translate3d(calc(" + (-self.i * 100) + "% + " +
                            Math.round(edge ? dx * .35 : dx) + "px),0,0)";
  }, { passive:false });
  function end(e){
    if (!d || e.pointerId !== d.id) return;
    var g = d; d = null;
    el.classList.remove("dragging");                   /* always restore the track, whatever the lock */
    void track.offsetWidth;                            /* transition from the finger, not the old seat */
    track.style.transform = "";
    /* a tap - no lock, no travel - opens the current view full screen */
    if (g.lock === null && e.type === "pointerup" &&
        Math.abs(e.clientX - g.x0) < 8 && Math.abs(e.clientY - g.y0) < 8 && g.tgt && g.tgt.closest(".view")){
      openLook(self);
      return;
    }
    if (g.lock !== "x") return;
    var n = self.views.length;
    var w = el.clientWidth || 360;
    var trip = Math.max(28, Math.min(56, w * 0.12));   /* a phone needs less travel than a desktop */
    var v = Math.abs(g.dx) / Math.max(1, performance.now() - g.t0);
    var to = self.i;
    if (g.dx <= -trip || (g.dx < -12 && v > .45)) to = Math.min(self.i + 1, n - 1);
    else if (g.dx >= trip || (g.dx > 12 && v > .45)) to = Math.max(self.i - 1, 0);
    self.seat(to);
  }
  el.addEventListener("pointerup", end);
  el.addEventListener("pointercancel", end);
  el.addEventListener("lostpointercapture", function(e){
    /* only a real loss on the stage itself ends the drag.  The one that bubbles up from a
       child when capture moves TO the stage must be ignored. */
    if (e.target !== el) return;
    if (el.hasPointerCapture && el.hasPointerCapture(e.pointerId)) return;
    end(e);
  });
};

function stageOf(panel){
  for (var k = 0; k < stages.length; k++) if (stages[k].panel === panel) return stages[k];
  return { set: function(){} };
}
document.querySelectorAll(".panel").forEach(function(panel){
  if (panel.querySelector("[data-stage]")) stages.push(new Stage(panel));
});

/* ------------------------------- the viewer ------------------------------- */
/* Tap any view and it fills the screen; swipe, chips or arrows move it, and the panel's
   own stage follows, so closing lands on what you were just looking at. */
var lookEl = document.getElementById("look"), lookStage = null;
function openLook(stage){
  lookStage = stage;
  opener = stage.rail.querySelector('[aria-pressed="true"]') || stage.rail.querySelector("button");
  go("#look");
  refreshLook();
}
var lookZoomReset = null;          /* set by the viewer once its zoom state exists */
function refreshLook(){
  if (!lookStage) return;
  var body = lookEl.querySelector("[data-look-body]"), gal = lookEl.querySelector("[data-look-gal]");
  var v = lookStage.views[lookStage.i];
  if (lookZoomReset) lookZoomReset();   /* a new photograph has its own 1x size */
  body.textContent = "";
  var im = v.querySelector("img");
  if (im){
    var big = document.createElement("img");
    big.src = im.getAttribute("src") || im.dataset.src;
    big.alt = im.alt || "";
    big.draggable = false;
    body.appendChild(big);
  }
  gal.textContent = "";
  lookStage.views.forEach(function(view, n){
    var b = document.createElement("button");
    b.type = "button";
    b.textContent = view.dataset.label || "View";
    b.setAttribute("aria-pressed", String(n === lookStage.i));
    b.addEventListener("click", function(){ lookStage.seat(n); refreshLook(); });
    gal.appendChild(b);
  });
  lookEl.querySelector('[data-look-step="-1"]').hidden = lookStage.i === 0;
  lookEl.querySelector('[data-look-step="1"]').hidden = lookStage.i >= lookStage.views.length - 1;
  lookEl.querySelector("[data-look-count]").textContent = (lookStage.i + 1) + " / " + lookStage.views.length;
  var nm = lookStage.panel.querySelector(".name");
  lookEl.querySelector("[data-look-title]").textContent =
    (nm ? (nm.getAttribute("aria-label") || nm.textContent) : "") + " " + DOT + " " +
    (lookStage.el.dataset.ground || "") + " " + DOT + " " + (v.dataset.label || "View");
  body.classList.remove("zoomed");
}
[].slice.call(lookEl.querySelectorAll("[data-look-step]")).forEach(function(b){
  b.addEventListener("click", function(){ lookStep(parseInt(b.dataset.lookStep, 10)); });
});
function lookStep(dir){
  if (!lookStage) return;
  var n = lookStage.i + dir;
  if (n < 0 || n >= lookStage.views.length) return;
  lookStage.seat(n); refreshLook();
  if (live) live.textContent = (lookStage.views[n].dataset.label || "View") + " view";
}
/* the viewer: swipe steps; a double tap zooms into the print at that point (2.6x); pinch
   zooms between 1x and 4x; while zoomed a drag pans and a double tap goes back to 1x.
   Everything is one transform on the img, and a new view always starts at 1x. */
(function(){
  var body = lookEl.querySelector("[data-look-body]"), d = null;
  var z = { s:1, tx:0, ty:0, bw:0, bh:0 }, ptrs = {}, pinch = null, lastTap = 0;
  lookZoomReset = function(){
    z.s = 1; z.tx = 0; z.ty = 0; z.bw = 0; z.bh = 0;
    body.classList.remove("zoomed");
  };
  function img(){ return body.querySelector("img"); }
  function apply(anim){
    var im = img(); if (!im) return;
    if (!z.bw){ z.bw = im.offsetWidth; z.bh = im.offsetHeight; }   /* the contain size at 1x */
    if (z.s <= 1.001){
      z.s = 1; z.tx = 0; z.ty = 0;
      im.classList.toggle("zoomanim", !!anim && !RM.matches);
      im.style.width = ""; im.style.height = ""; im.style.transform = "";
      body.classList.remove("zoomed");
      return;
    }
    var r = body.getBoundingClientRect();
    var w = z.bw * z.s, h = z.bh * z.s;
    /* the image is centred by flex, so its travel is symmetric about the middle and it can
       never be dragged away from covering the frame */
    var mx = Math.max(0, (w - r.width) / 2), my = Math.max(0, (h - r.height) / 2);
    z.tx = Math.max(-mx, Math.min(mx, z.tx));
    z.ty = Math.max(-my, Math.min(my, z.ty));
    body.classList.add("zoomed");
    im.classList.toggle("zoomanim", !!anim && !RM.matches);
    im.style.width = Math.round(w) + "px";
    im.style.height = Math.round(h) + "px";
    im.style.transform = "translate(" + Math.round(z.tx) + "px," + Math.round(z.ty) + "px)";
  }
  /* Zoom about a point: whatever was under the finger stays under the finger. Solved against the
     flex-centred layout box rather than the transformed rect, which is what the old version got
     wrong - it mixed a post-transform getBoundingClientRect with a pre-transform offset. */
  function zoomAt(px, py, s, anim){
    var im = img(); if (!im) return;
    if (!z.bw){ z.bw = im.offsetWidth; z.bh = im.offsetHeight; }
    var r = body.getBoundingClientRect();
    var s0 = z.s;
    var left0 = r.left + (r.width - z.bw * s0) / 2 + z.tx;
    var top0 = r.top + (r.height - z.bh * s0) / 2 + z.ty;
    var u = (px - left0) / (z.bw * s0);                 /* 0..1 across the photograph */
    var v = (py - top0) / (z.bh * s0);
    u = Math.max(0, Math.min(1, u)); v = Math.max(0, Math.min(1, v));
    z.s = Math.max(1, Math.min(4, s));
    z.tx = px - r.left - (r.width - z.bw * z.s) / 2 - u * z.bw * z.s;
    z.ty = py - r.top - (r.height - z.bh * z.s) / 2 - v * z.bh * z.s;
    apply(anim);
  }
  body.addEventListener("pointerdown", function(e){
    if (e.pointerType === "mouse" && e.button !== 0) return;
    ptrs[e.pointerId] = { x:e.clientX, y:e.clientY };
    var ids = Object.keys(ptrs);
    if (ids.length === 2){
      var a = ptrs[ids[0]], b = ptrs[ids[1]];
      pinch = { d0:Math.hypot(a.x - b.x, a.y - b.y), s0:z.s }; d = null; return;
    }
    if (!e.isPrimary) return;
    d = { id:e.pointerId, x0:e.clientX, y0:e.clientY, x:e.clientX, y:e.clientY, moved:false };
  });
  body.addEventListener("pointermove", function(e){
    if (!ptrs[e.pointerId]) return;
    ptrs[e.pointerId] = { x:e.clientX, y:e.clientY };
    var ids = Object.keys(ptrs);
    if (pinch && ids.length >= 2){
      var a = ptrs[ids[0]], b = ptrs[ids[1]];
      zoomAt((a.x + b.x) / 2, (a.y + b.y) / 2, pinch.s0 * Math.hypot(a.x - b.x, a.y - b.y) / pinch.d0);
      return;
    }
    if (!d || e.pointerId !== d.id) return;
    var dx = e.clientX - d.x, dy = e.clientY - d.y; d.x = e.clientX; d.y = e.clientY;
    if (Math.abs(e.clientX - d.x0) > 8 || Math.abs(e.clientY - d.y0) > 8) d.moved = true;
    if (z.s > 1){ z.tx += dx; z.ty += dy; apply(); e.preventDefault(); }
  });
  function end(e){
    delete ptrs[e.pointerId];
    if (pinch){ if (!Object.keys(ptrs).length) pinch = null; d = null; return; }
    if (!d || e.pointerId !== d.id) return;
    var g = d; d = null;
    var dx = e.clientX - g.x0, dy = e.clientY - g.y0;
    if (z.s === 1 && Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)){ lookStep(dx < 0 ? 1 : -1); return; }
    if (!g.moved){
      var now = Date.now();
      if (now - lastTap < 320){ lastTap = 0;
        if (z.s > 1){ z.s = 1; apply(true); } else zoomAt(e.clientX, e.clientY, 2.6, true); }
      else lastTap = now;
    }
  }
  body.addEventListener("pointerup", end);
  body.addEventListener("pointercancel", function(e){ delete ptrs[e.pointerId]; pinch = null; d = null; });
  body.addEventListener("dblclick", function(e){ e.preventDefault(); });
  lookEl.addEventListener("wheel", function(e){
    if (!lookStage || !e.ctrlKey) return;                       /* trackpad pinch on desktop */
    e.preventDefault(); zoomAt(e.clientX, e.clientY, z.s * (e.deltaY < 0 ? 1.12 : 0.9));
  }, { passive:false });
  lookEl.querySelector("[data-close]").addEventListener("click", function(){ z.s = 1; apply(); });
  lookEl.addEventListener("keydown", function(e){
    if (e.key === "ArrowRight") lookStep(1);
    else if (e.key === "ArrowLeft") lookStep(-1);
  });
})();

/* -------------------------------- bag -------------------------------- */
function bagCount(){ return bag.reduce(function(n,l){ return n + l.qty; }, 0); }
function syncCount(){
  var b = document.getElementById("ct"), n = bagCount();
  b.textContent = String(n);
  document.getElementById("bagbtn").setAttribute("aria-label", "Bag, " + n + " item" + (n===1?"":"s"));
  b.classList.remove("tick"); void b.offsetWidth; if (!RM.matches) b.classList.add("tick");
}
function addToBag(key, cw, size){
  var cap = DATA[key][cw][size].q;
  var line = bag.filter(function(l){ return l.key===key && l.cw===cw && l.size===size; })[0];
  if (line){ if (line.qty < cap) line.qty += 1; }
  else bag.push({ key:key, cw:cw, size:size, qty:1 });
  syncCount(); renderBag();
}
function renderBag(){
  var host = document.getElementById("bagbody");
  host.textContent = "";
  if (!bag.length){
    var e = document.createElement("p");
    e.className = "empty"; e.textContent = "Nothing yet.";
    var bk = document.createElement("button");
    bk.type = "button"; bk.className = "backlink"; bk.textContent = "Back to the drop";
    bk.addEventListener("click", closeOverlay);
    host.appendChild(e); host.appendChild(bk);
    return;
  }
  bag.forEach(function(l){
    var cap = DATA[l.key][l.cw][l.size].q;
    var row = document.createElement("div");
    row.className = "row";
    var th = document.createElement("div"); th.className = "thumb";
    var im = document.createElement("img");
    /* the bag shows the tee in the colourway chosen; the film art is the fallback */
    var srcEl = document.querySelector('[data-img-src="rd-' + l.key + '-' + (l.cw === "Ivory" ? "ivy" : "blk") + '-front"]') ||
                document.querySelector('[data-img-src="' + DATA[l.key].img + '"]');
    var uri = srcEl && (srcEl.getAttribute("src") || srcEl.dataset.src);
    if (uri) im.src = uri;
    im.alt = "";
    var mid = document.createElement("div");
    var nm = document.createElement("p"); nm.className = "rname"; nm.textContent = DATA[l.key].title;
    var mt = document.createElement("p"); mt.className = "rmeta";
    mt.textContent = l.cw + " " + DOT + " " + l.size + " " + DOT + " $" + PRICE;
    var q = document.createElement("div"); q.className = "qty";
    var minus = document.createElement("button"); minus.type = "button";
    minus.textContent = "−"; minus.setAttribute("aria-label", "Decrease quantity");
    var num = document.createElement("span"); num.textContent = String(l.qty);
    var plus = document.createElement("button"); plus.type = "button";
    plus.textContent = "+"; plus.setAttribute("aria-label", "Increase quantity");
    plus.disabled = l.qty >= cap;
    minus.addEventListener("click", function(){
      l.qty -= 1;
      if (l.qty <= 0) bag.splice(bag.indexOf(l), 1);
      syncCount(); renderBag();
    });
    plus.addEventListener("click", function(){
      if (l.qty >= cap) return;
      l.qty += 1; syncCount(); renderBag();
    });
    q.appendChild(minus); q.appendChild(num); q.appendChild(plus);
    mid.appendChild(nm); mid.appendChild(mt); mid.appendChild(q);
    var rm = document.createElement("button");
    rm.type = "button"; rm.className = "rm"; rm.textContent = "Remove";
    rm.setAttribute("aria-label", "Remove " + DATA[l.key].title + " " + l.cw + " " + l.size);
    rm.addEventListener("click", function(){
      bag.splice(bag.indexOf(l), 1); syncCount(); renderBag();
    });
    th.appendChild(im); row.appendChild(th); row.appendChild(mid); row.appendChild(rm);
    host.appendChild(row);
  });
  var tot = document.createElement("div");
  tot.className = "tot";
  var tl = document.createElement("span"); tl.textContent = "Subtotal";
  var tr = document.createElement("span"); tr.textContent = "$" + (bagCount() * PRICE);
  tot.appendChild(tl); tot.appendChild(tr);
  host.appendChild(tot);
  var note = document.createElement("p");
  note.className = "rmeta"; note.style.marginTop = "10px";
  note.textContent = "FREE US SHIPPING, NO MINIMUM";
  host.appendChild(note);
  var co = document.createElement("button");
  co.className = "co"; co.type = "button"; co.disabled = !bag.length;
  co.textContent = bag.length ? "Checkout" : "Your bag is empty";
  co.addEventListener("click", function(){ if (bag.length) window.location.href = "/checkout"; });
  host.appendChild(co);
  /* the reassurance sits where the decision is made, not on the product panel */
  var sec = document.createElement("p");
  sec.className = "rmeta"; sec.style.marginTop = "10px"; sec.style.textAlign = "center";
  sec.textContent = "SECURE CHECKOUT";
  host.appendChild(sec);
}

/* ------------------------------- forms ------------------------------- */
document.querySelectorAll("form").forEach(function(form){
  if (form.querySelector('[name="form_type"]')) return;   /* a real Shopify form posts itself */
  form.addEventListener("submit", function(e){
    e.preventDefault();
    var input = form.querySelector("input");
    var v = (input.value || "").trim();
    var at = v.indexOf("@");
    var ok = at > 0 && v.indexOf(".", at) > at + 1 && v.indexOf(" ") < 0 && at === v.lastIndexOf("@");
    var err = form.parentNode.querySelector(".errline");
    if (!ok){
      form.classList.add("bad");
      if (!err){
        err = document.createElement("p");
        err.className = "errline";
        err.setAttribute("role", "status");
        form.parentNode.insertBefore(err, form.nextSibling);
      }
      err.textContent = "Enter an email address";
      input.focus();
      setTimeout(function(){ form.classList.remove("bad"); }, 900);
      return;
    }
    if (err) err.remove();
    var h = form.offsetHeight;
    var done = document.createElement("p");
    done.className = "done";
    done.setAttribute("role", "status");
    done.style.minHeight = h + "px";
    done.textContent = "On the list " + DASH + " you'll hear first";
    var isGap = form.dataset.src === "gap";
    form.parentNode.replaceChild(done, form);
    var gap = document.getElementById("p4");
    if (isGap && gap && !RM.matches){
      gap.classList.remove("gp-joined"); void gap.offsetWidth; gap.classList.add("gp-joined");
    }
  });
});

/* ----------------------- signatures: arm and fire ---------------------- */
var overlayOpen = false, pending = null;

function fire(panel){
  if (RM.matches || panel.dataset.fired) return;
  /* pre-roll and fire are one operation: a panel is never left in the pre-roll
     state, so a signature that never runs degrades to the composed page. */
  panel.classList.add("armed");
  void panel.offsetWidth;
  if (panel.getAnimations)
    panel.getAnimations({subtree:true}).forEach(function(a){ a.cancel(); });
  var land = function(){
    panel.dataset.fired = "1";
    panel.classList.add("fire");
  };
  requestAnimationFrame(land);
  setTimeout(land, 250);   /* rAF never runs in a fully hidden tab - never strand the pre-roll */
}

var io = new IntersectionObserver(function(es){
  es.forEach(function(e){
    if (!e.isIntersecting) return;
    if (overlayOpen){ pending = e.target; return; }
    e.target.classList.add("in");
    fire(e.target);
    io.unobserve(e.target);
  });
}, {threshold:.25});

document.querySelectorAll(".panel").forEach(function(p){ io.observe(p); });

RM.addEventListener("change", function(e){
  if (e.matches) document.querySelectorAll(".armed").forEach(function(p){
    p.classList.remove("armed","fire");
  });

});

/* decode the next panel's bitmaps before you arrive on it */
var io2 = new IntersectionObserver(function(es){
  es.forEach(function(e){
    if (!e.isIntersecting) return;
    e.target.querySelectorAll("img").forEach(function(im){
      if (im.src && im.decode) im.decode().catch(function(){});
    });
    io2.unobserve(e.target);
  });
}, {rootMargin:"120% 0px"});
document.querySelectorAll(".panel").forEach(function(p){ io2.observe(p); });

/* ------------------------------ the rail ------------------------------ */
var rail = document.getElementById("rail");
var railLinks = [].slice.call(rail.querySelectorAll("a"));
var spy = new IntersectionObserver(function(es){
  es.forEach(function(e){
    if (!e.isIntersecting) return;
    railLinks.forEach(function(a){
      a.setAttribute("aria-current", String(a.getAttribute("href") === "#" + e.target.id));
    });
  });
}, {threshold:.5});
document.querySelectorAll(".panel").forEach(function(p){ spy.observe(p); });

document.querySelectorAll('a[href^="#p"]').forEach(function(a){
  a.addEventListener("click", function(e){
    var t = document.querySelector(a.getAttribute("href"));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: RM.matches ? "auto" : "smooth", block: "start" });
    history.replaceState(null, "", a.getAttribute("href"));
  });
});

/* ------------------------- overlays and routing ------------------------ */
var scrimx = document.getElementById("scrimx");
var openEl = null, opener = null, lastY = 0;
var hasInert = "inert" in HTMLElement.prototype;

function shield(on){
  [document.getElementById("feed"), document.querySelector(".hdr")].forEach(function(node){
    if (hasInert){ node.inert = on; return; }
    node.setAttribute("aria-hidden", String(on));
    node.querySelectorAll("a,button,input,[tabindex]").forEach(function(el){
      if (on){ if (!("ti" in el.dataset)) el.dataset.ti = el.getAttribute("tabindex") || ""; el.setAttribute("tabindex","-1"); }
      else { if (el.dataset.ti) el.setAttribute("tabindex", el.dataset.ti);
             else el.removeAttribute("tabindex"); delete el.dataset.ti; }
    });
  });
}
function lockScroll(){
  lastY = window.scrollY;
  root.style.scrollSnapType = "none";
  document.body.style.position = "fixed";
  document.body.style.top = (-lastY) + "px";
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
}
function unlockScroll(){
  var prevBehavior = root.style.scrollBehavior;
  root.style.scrollBehavior = "auto";
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  void document.body.offsetHeight;      /* the document has to be tall again first */
  window.scrollTo(0, lastY);
  requestAnimationFrame(function(){
    window.scrollTo(0, lastY);          /* second seat after layout settles */
    root.style.scrollBehavior = prevBehavior;
    root.style.scrollSnapType = "";
  });
}
function currentPanel(){
  var cur = railLinks.filter(function(a){ return a.getAttribute("aria-current") === "true"; })[0];
  return cur ? cur.getAttribute("href").slice(2) : "1";
}
var closing_ = false;                 /* two Escapes inside the close animation used to pop
                                         history twice and throw you off the panel entirely */
function closeOverlay(){
  if (closing_) return;
  closing_ = true;
  setTimeout(function(){ closing_ = false; }, 420);
  /* close is a POP, not a push. Pushing on close meant every open/close pair added two
     history entries and the phone's Back button re-opened the sheet you just dismissed. */
  var st = history.state;
  if (st && st.v && /^#(piece-|shipping$|bag$|faq$|fit$|look$)/.test(st.v)) { history.back(); return; }
  var here = "#p" + currentPanel();
  render(here);
  history.replaceState(null, "", here);
}
function trap(e){
  if (e.key === "Escape"){ e.preventDefault(); closeOverlay(); return; }
  if (e.key !== "Tab" || !openEl) return;
  var f = [].slice.call(openEl.querySelectorAll(
    'button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])'
  )).filter(function(el){ return !el.disabled && el.offsetParent !== null; });
  if (!f.length) return;
  var first = f[0], last = f[f.length - 1];
  if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
}

function render(view){
  if (view === "#look" && !lookStage) view = "#p" + currentPanel();   /* a deep link to the viewer has nothing to show */
  /* The hash comes from the URL, so it is untrusted input. The old pattern let anything follow
     "#piece-", and "#piece-:::" or a quote reached querySelector and threw an uncaught
     SyntaxError - a crafted link was enough. Anchored, and only the characters an id can hold. */
  var target = /^#(?:piece-[a-z0-9-]+|shipping|bag|faq|fit|look)$/.test(view)
             ? document.getElementById(view.slice(1)) : null;
  if (openEl && openEl !== target){
    var closing = openEl;
    closing.classList.remove("on");
    setTimeout(function(){ if (closing !== openEl) closing.hidden = true; }, 360);
    openEl = null;
  }
  if (target){
    if (!overlayOpen) lockScroll();
    openEl = target;
    overlayOpen = true;
    overlayHold = true;
    stages.forEach(function(st){ st.sync(); });
    target.hidden = false;
    void target.offsetWidth;
    target.classList.add("on");
    scrimx.classList.add("on");
    shield(true);
    document.addEventListener("keydown", trap);
    var x = target.querySelector(".x");
    if (x) x.focus({preventScroll:true});
    if (target.id === "piece-grew" && !RM.matches){
      target.classList.remove("fire"); void target.offsetWidth; target.classList.add("fire");
    }
  } else if (overlayOpen){
    scrimx.classList.remove("on");
    document.removeEventListener("keydown", trap);
    overlayOpen = false;
    overlayHold = false;
    stages.forEach(function(st){ st.sync(); });
    shield(false);
    unlockScroll();
    if (opener){ opener.focus({preventScroll:true}); opener = null; }
    if (pending){ pending.classList.add("in"); fire(pending); io.unobserve(pending); pending = null; }
  }
}
function go(view){
  render(view);
  /* never stack the same view twice.  Tapping the bag icon while the bag was already open
     used to push a second #bag entry, and then Escape (and the phone's own Back button)
     popped from #bag straight to #bag - the sheet would not close. */
  if (history.state && history.state.v === view) return;
  history.pushState({v:view}, "", view);
}
document.querySelectorAll("[data-sheet]").forEach(function(b){
  b.addEventListener("click", function(e){
    e.preventDefault();
    if (overlayOpen){                 /* sheet -> sheet: swap in place, one Back still closes */
      render(b.dataset.sheet);
      /* a deep-linked sheet was opened at load with nothing pushed: push now, or the close's
         history.back() would pop the page itself and throw the visitor off the site */
      var pushed = history.state && history.state.v;
      if (pushed) history.replaceState({v:b.dataset.sheet}, "", b.dataset.sheet);
      else history.pushState({v:b.dataset.sheet}, "", b.dataset.sheet);
      return;
    }
    opener = b;
    go(b.dataset.sheet);
  });
});
document.getElementById("bagbtn").addEventListener("click", function(){
  opener = this; go("#bag");
});
document.querySelectorAll("[data-close]").forEach(function(b){
  b.addEventListener("click", closeOverlay);
});
scrimx.addEventListener("click", closeOverlay);
window.addEventListener("popstate", function(){ render(location.hash || "#p1"); });

/* Swipe-down dismiss, armed only at the top of the sheet AND only for one finger.
   This tracked touches[0] and never looked at how many fingers were down, so pinching to zoom
   a print threw the viewer away: spread two fingers, the lower one travels more than 80px, and
   touchend read that as "drag to dismiss" (Jose, 7 Sep - "it kicks me out to the normal page").
   A second finger now disarms it outright and puts the sheet back where it was. */
document.querySelectorAll(".sheet").forEach(function(sheet){
  var y0 = 0, dragArmed = false;
  function disarm(){
    dragArmed = false;
    if (sheet.style.transform) sheet.style.transform = "";
  }
  sheet.addEventListener("touchstart", function(e){
    if (e.touches.length > 1){ disarm(); return; }      /* a pinch is never a dismiss */
    y0 = e.touches[0].clientY;
    dragArmed = sheet.scrollTop <= 0 && !sheet.querySelector(".look-body.zoomed");
  }, {passive:true});
  sheet.addEventListener("touchmove", function(e){
    if (e.touches.length > 1){ disarm(); return; }      /* a second finger arrived mid-gesture */
    if (!dragArmed) return;
    var dy = e.touches[0].clientY - y0;
    if (dy > 0) sheet.style.transform = "translateY(" + dy + "px)";
  }, {passive:true});
  sheet.addEventListener("touchend", function(e){
    var dy = e.changedTouches[0].clientY - y0;
    var armed = dragArmed && e.touches.length === 0;    /* only when the last finger leaves */
    sheet.style.transform = "";
    dragArmed = false;
    if (armed && dy > 80) closeOverlay();
  });
});

/* ------------------------- keyboard and snap ------------------------- */
document.addEventListener("focusin", function(e){
  if (e.target.matches("input,textarea")){
    root.style.scrollSnapType = "none";
    requestAnimationFrame(function(){ e.target.scrollIntoView({block:"center", behavior:"smooth"}); });
  }
});
document.addEventListener("focusout", function(e){
  if (e.target.matches("input,textarea") && !overlayOpen)
    setTimeout(function(){ root.style.scrollSnapType = ""; }, 120);
});

/* -------------------------------- boot -------------------------------- */
var boot = document.getElementById("boot");
var seen = false;
try { seen = sessionStorage.getItem("as_boot") === "1"; sessionStorage.setItem("as_boot", "1"); } catch(e){}

function lift(){
  if (!boot) return;
  boot.style.pointerEvents = "none";
  boot.classList.add("gone");
  setTimeout(function(){ if (boot){ boot.remove(); boot = null; } }, 700);
}
if (seen || RM.matches){ if (boot){ boot.remove(); boot = null; } }
else {
  var hero = document.querySelector("#p1 .view--film img");
  var ready = (hero && hero.decode) ? hero.decode().catch(function(){}) : Promise.resolve();
  Promise.race([ ready, new Promise(function(r){ setTimeout(r, 420); }) ])
         .then(function(){ setTimeout(lift, 60); });
  setTimeout(lift, 900);                      /* never hold the page, whatever the network does */
}

/* ------------------------- first paint routing ------------------------- */
renderBag();
(function(){
  var h = location.hash;
  var owner = { "#piece-struck":"p1", "#piece-stratum":"p2", "#piece-grew":"p3", "#piece-gap":"p4" };
  if (/^#(piece-|shipping$|bag$|faq$|fit$|look$)/.test(h) && document.querySelector(h)){
    if (owner[h]){
      var el = document.getElementById(owner[h]);
      if (el) el.scrollIntoView({behavior:"instant", block:"start"});
    }
    render(h);
  } else if (/^#p[1-5]$/.test(h)){
    var t = document.querySelector(h);
    if (t){
      t.scrollIntoView({behavior:"instant", block:"start"});
      /* layout grows as the bitmaps decode - re-seat the deep link once it has */
      window.addEventListener("load", function(){
        requestAnimationFrame(function(){ t.scrollIntoView({behavior:"instant", block:"start"}); });
      });
    }
  } else if (h){
    history.replaceState(null, "", "#p1");
  }
})();

/* ------------------------------------------------------------------------------------------
   The bag becomes Shopify's real cart.

   In the mockup the bag is an array in the browser and checkout is a disabled button that says
   so, honestly. In the store it has to be the actual cart or the page is a very pretty way of
   collecting nothing.

   /cart/add.js and /cart.js are Shopify's own AJAX endpoints: no app, no API key, no token in
   this file. The session is the browser's own first-party cookie, which is why every request
   below sends credentials: "same-origin" and nothing else.

   This file is APPENDED to as-feed.js by make_theme.py, so these declarations replace the
   mockup's earlier ones. Hoisting means the last function declaration in a scope is the one
   that runs — including for calls that appear above it.
   ------------------------------------------------------------------------------------------ */

var CART_TOTAL = null;

/* Optimistic: the line appears immediately, then the server's answer overwrites it. If the add
   fails — someone bought the last one thirty seconds ago — the bag snaps back to the truth and
   the customer is told, instead of being sent to a checkout that will reject them. */
function addToBag(key, cw, size) {
  var slot = DATA[key] && DATA[key][cw] && DATA[key][cw][size];
  var cap = slot ? slot.q : 0;
  var line = bag.filter(function (l) { return l.key === key && l.cw === cw && l.size === size; })[0];
  if (line) { if (line.qty < cap) line.qty += 1; }
  else bag.push({ key: key, cw: cw, size: size, qty: 1 });
  syncCount(); renderBag();

  if (!slot || !slot.id || !window.fetch) return;
  fetch("/cart/add.js", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ items: [{ id: slot.id, quantity: 1 }] })
  }).then(function (r) {
    if (r.ok) return cartSync();
    return r.json().then(function (e) { throw e; });
  }).catch(function (e) {
    cartSync();
    var t = document.getElementById("toast");
    if (!t) return;
    t.textContent = (e && (e.description || e.message)) || "That one just went. Try another size.";
    t.classList.add("on");
    setTimeout(function () { t.classList.remove("on"); }, 3200);
  });
}

/* The server is the only truth about a cart. This makes the local bag match it, so a reload,
   a second tab, or an expired session can never leave a wrong number in the header. */
function cartSync() {
  if (!window.fetch) return Promise.resolve();
  return fetch("/cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var byId = {};
      Object.keys(DATA).forEach(function (k) {
        if (k.charAt(0) === "_") return;                 /* __price is not a product */
        ["Black", "Ivory"].forEach(function (cw) {
          if (!DATA[k][cw]) return;
          Object.keys(DATA[k][cw]).forEach(function (sz) {
            var v = DATA[k][cw][sz];
            if (v && v.id) byId[v.id] = { key: k, cw: cw, size: sz };
          });
        });
      });
      bag.length = 0;
      (cart.items || []).forEach(function (it) {
        var m = byId[it.variant_id];
        if (m) bag.push({ key: m.key, cw: m.cw, size: m.size, qty: it.quantity });
      });
      CART_TOTAL = cart.total_price;
      syncCount(); renderBag();
      return cart;
    })
    .catch(function () { /* offline: the optimistic bag still beats a blank one */ });
}

if (window.fetch) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { cartSync(); });
  } else {
    cartSync();
  }
}

/* ------------------------------------------------------------------------------------------
   8 Sep 2026 — the drawer's − / + / Remove only edited the local array. Shopify's cart kept
   the old quantity, so a customer who removed a shirt was still charged for it at checkout
   (reproduced live: drawer said $90, /cart.js said 3 x $45). Every change now goes to
   /cart/change.js and the server's answer (cartSync) is what the drawer ends up showing.
   ------------------------------------------------------------------------------------------ */
function setServerQty(l, qty) {
  var slot = DATA[l.key] && DATA[l.key][l.cw] && DATA[l.key][l.cw][l.size];
  if (!slot || !slot.id || !window.fetch) return;
  fetch("/cart/change.js", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ id: String(slot.id), quantity: qty })   /* change.js rejects a numeric id with 400 */
  }).then(function () { return cartSync(); }).catch(function () { cartSync(); });
}
function renderBag() {
  var host = document.getElementById("bagbody");
  host.textContent = "";
  if (!bag.length) {
    var e = document.createElement("p");
    e.className = "empty"; e.textContent = "Nothing yet.";
    var bk = document.createElement("button");
    bk.type = "button"; bk.className = "backlink"; bk.textContent = "Back to the drop";
    bk.addEventListener("click", closeOverlay);
    host.appendChild(e); host.appendChild(bk);
    return;
  }
  bag.forEach(function (l) {
    var cap = DATA[l.key][l.cw][l.size].q;
    var row = document.createElement("div");
    row.className = "row";
    var th = document.createElement("div"); th.className = "thumb";
    var im = document.createElement("img");
    var srcEl = document.querySelector('[data-img-src="rd-' + l.key + '-' + (l.cw === "Ivory" ? "ivy" : "blk") + '-front"]') ||
                document.querySelector('[data-img-src="' + DATA[l.key].img + '"]');
    var uri = srcEl && (srcEl.getAttribute("src") || srcEl.dataset.src);
    if (uri) im.src = uri;
    im.alt = "";
    var mid = document.createElement("div");
    var nm = document.createElement("p"); nm.className = "rname"; nm.textContent = DATA[l.key].title;
    var mt = document.createElement("p"); mt.className = "rmeta";
    mt.textContent = l.cw + " " + DOT + " " + l.size + " " + DOT + " $" + PRICE;
    var q = document.createElement("div"); q.className = "qty";
    var minus = document.createElement("button"); minus.type = "button";
    minus.textContent = "−"; minus.setAttribute("aria-label", "Decrease quantity");
    var num = document.createElement("span"); num.textContent = String(l.qty);
    var plus = document.createElement("button"); plus.type = "button";
    plus.textContent = "+"; plus.setAttribute("aria-label", "Increase quantity");
    plus.disabled = l.qty >= cap;
    minus.addEventListener("click", function () {
      l.qty -= 1;
      if (l.qty <= 0) bag.splice(bag.indexOf(l), 1);
      syncCount(); renderBag();
      setServerQty(l, Math.max(l.qty, 0));
    });
    plus.addEventListener("click", function () {
      if (l.qty >= cap) return;
      l.qty += 1; syncCount(); renderBag();
      setServerQty(l, l.qty);
    });
    q.appendChild(minus); q.appendChild(num); q.appendChild(plus);
    mid.appendChild(nm); mid.appendChild(mt); mid.appendChild(q);
    var rm = document.createElement("button");
    rm.type = "button"; rm.className = "rm"; rm.textContent = "Remove";
    rm.setAttribute("aria-label", "Remove " + DATA[l.key].title + " " + l.cw + " " + l.size);
    rm.addEventListener("click", function () {
      bag.splice(bag.indexOf(l), 1); syncCount(); renderBag();
      setServerQty(l, 0);
    });
    th.appendChild(im); row.appendChild(th); row.appendChild(mid); row.appendChild(rm);
    host.appendChild(row);
  });
  var tot = document.createElement("div");
  tot.className = "tot";
  var tl = document.createElement("span"); tl.textContent = "Subtotal";
  var tr = document.createElement("span"); tr.textContent = "$" + (bagCount() * PRICE);
  tot.appendChild(tl); tot.appendChild(tr);
  host.appendChild(tot);
  var note = document.createElement("p");
  note.className = "rmeta"; note.style.marginTop = "10px";
  note.textContent = "FREE US SHIPPING, NO MINIMUM";
  host.appendChild(note);
  var co = document.createElement("button");
  co.className = "co"; co.type = "button"; co.disabled = !bag.length;
  co.textContent = bag.length ? "Checkout" : "Your bag is empty";
  co.addEventListener("click", function () { if (bag.length) window.location.href = "/checkout"; });
  host.appendChild(co);
  var sec = document.createElement("p");
  sec.className = "rmeta"; sec.style.marginTop = "10px"; sec.style.textAlign = "center";
  sec.textContent = "SECURE CHECKOUT";
  host.appendChild(sec);
}

/* Worn views, part two (10 Sep 2026). Appended after the page code, so the Stages exist.
   1. A worn view has no Ivory twin, so switching colourway from one fell back to Film - the jump to
      the artwork slide that set()'s own label matching was written to prevent. Land on the same
      side instead: Worn -> Front, Worn back -> Back.
   2. Appending the worn views moved Back out of the wrap-around neighbour that seat() preloads at
      start, so a first tap on Back showed an empty studio square while its render downloaded.
      Start Back's download when its panel comes within a screen, the way io2 decodes.
   4. (11 Sep) A press that holds, or that lands on a page still gliding from a flick, is not a tap.
      The stage opened the full-screen viewer on any press that lifted within 8px, so holding a
      finger on a photo while scrolling - or touching to stop a scroll - threw the photo full
      screen and back (Jose: "random zooming in and out when I'm scrolling and I hold to scroll").
      Only a short press (under 350ms) on a page that was not moving opens it now. */
(function(){
  if (typeof Stage !== "function" || typeof stages === "undefined") return;
  var set = Stage.prototype.set;
  Stage.prototype.set = function(){
    var cur = this.views.length ? this.views[this.i] : null;
    var label = (cur && cur.getAttribute("data-label")) || "";
    set.apply(this, arguments);
    if (label.indexOf("Worn") !== 0) return;
    var now = this.views[this.i];
    if (now && now.getAttribute("data-label") === label) return;
    var want = label === "Worn back" ? "Back" : "Front";
    for (var q = 0; q < this.views.length; q++)
      if (this.views[q].getAttribute("data-label") === want){ this.seat(q, true); return; }
  };

  var lastScroll = -1e9, press = { down: 0, at: -1e9, moving: false, tap: true };
  window.addEventListener("scroll", function(){ lastScroll = performance.now(); }, { passive: true });
  stages.forEach(function(s){
    /* capture phase: these run before the stage's own pointerup decides to open the viewer */
    s.el.addEventListener("pointerdown", function(){
      press.down = performance.now();
      press.moving = press.down - lastScroll < 250;
    }, { capture: true, passive: true });
    s.el.addEventListener("pointerup", function(){
      press.at = performance.now();
      press.tap = !press.moving && press.at - press.down < 350 && lastScroll < press.down;
    }, { capture: true, passive: true });
  });
  if (typeof openLook === "function"){
    var open = openLook;
    openLook = function(){
      if (performance.now() - press.at < 60 && !press.tap) return;   /* this press was a hold or a flick-stop */
      return open.apply(this, arguments);
    };
  }

  /* 3. "STRATUM HEAD . BLACK . WORN BACK" is too long for the fullscreen viewer's title on a phone
        (30px over at 390 even in Consolas; SF Mono is wider) and ended in an ellipsis. Only when
        the title overflows, drop the colourway: worn views are black-only and the page says so. */
  if (typeof refreshLook === "function"){
    var refresh = refreshLook;
    refreshLook = function(){
      refresh.apply(this, arguments);
      var t = document.querySelector("#look .look-title");
      var sep = " " + String.fromCharCode(183) + " ";   /* ASCII source: a literal middle dot can mojibake */
      if (t && t.scrollWidth > t.clientWidth)
        t.textContent = t.textContent.split(sep).filter(function(part){ return part !== "Black" && part !== "Ivory"; }).join(sep);
    };
  }

  function warm(stage){
    stage.views.forEach(function(v){
      if (v.getAttribute("data-label") !== "Back") return;
      var im = v.querySelector("img");
      if (im && !im.getAttribute("src") && im.getAttribute("data-src")) im.src = im.getAttribute("data-src");
    });
  }
  if (!("IntersectionObserver" in window)){ stages.forEach(warm); return; }
  var io3 = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (!e.isIntersecting) return;
      stages.forEach(function(s){ if (s.panel === e.target) warm(s); });
      io3.unobserve(e.target);
    });
  }, {rootMargin: "120% 0px"});
  stages.forEach(function(s){ io3.observe(s.panel); });
})();
